import { type } from "@testing-library/user-event/dist/type";

export const storageApi = `https://tas.611systems.com/storage/app/public/`;
export const apiBaseUrl = `https://tas.611systems.com/public/`;

export const genderOptions = [
  { value: "", label: "Select Gender" },
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
];

export const experienceLevelOptions = [
  { id: 0, value: "", label: "Select Experience Level" },
  { id: 1, value: "1", label: "No BPO Experience " },
  { id: 2, value: "1", label: "With BPO Experience but less than 1 year" },
  { id: 3, value: "2", label: "With BPO Experience 1 Year and Above" },
  { id: 4, value: "3", label: "Team Leader" },
  { id: 5, value: "2", label: "Special Hired" },
  { id: 6, value: "6", label: "Admin Support – Maintenance & Security" },
];

export const civilStatusOptions = [
  { value: "", label: "Select Civil Status" },
  { value: "single", label: "Single" },
  { value: "married", label: "Married" },
  { value: "widowed", label: "Widowed" },
  { value: "divorced", label: "Divorced" },
];

export const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
};

export const prehiringQuestion = {
  title: "Questionnaire",
  totalQuestions: 15,
  questions: [
    {
      id: 1,
      text: "Are you willing to commit at least 1 year of working with the company if we decide to hire you?",
      options: ["Yes", "No"],
    },
    {
      id: 2,
      text: "When you sign a contract with our company, a minimum commitment period of one year is expected and required. If you choose to voluntarily resign or leave your position before completing this period, a penalty of 40,000 PHP will be imposed.",
      options: ["Yes I agree to this", "No, I would like to decline"],
    },
    {
      id: 3,
      text: "Are you presently enrolled in any school or university (college, senior high school etc)?",
      options: ["Yes", "No"],
    },
    {
      id: 4,
      text: "If no, do you plan to go back to school in a few months?",
      options: ["Yes", "No", "Not applicable"],
    },
    {
      id: 5,
      text: "To help us better understand your availability and long-term plans, is there anything in the next few months that might affect your ability to commit to this role?",
      options: ["Yes", "No", "For Female, Maternity"],
    },
    {
      id: 6,
      text: "Are you exploring opportunities with other companies at the moment?",
      options: ["Yes", "No"],
    },
    {
      id: 7,
      text: "Are you currently working in any job or any call center company?",
      options: ["Yes", "No"],
    },
    {
      id: 8,
      text: "Are you open to undergoing training and receiving a training allowance during the process?",
      options: ["Yes", "No"],
    },
    {
      id: 9,
      text: "Are you comfortable working during graveyard shifts, on weekends, holidays, or with a flexible schedule?",
      options: ["Yes", "No"],
    },
    {
      id: 10,
      text: "We have offices in MAA, MABINI and ECOLAND Site, Are you open to being assigned to either location?",
      options: ["Yes", "No"],
    },
    {
      id: 11,
      text: "If ever you fail the assessment for the position, will you consider other job offers?",
      options: ["Yes", "No"],
    },
    {
      id: 12,
      text: "Are you currently in any form of litigation or facing an active court case?",
      options: ["Yes", "No"],
    },
    {
      id: 13,
      text: "Do you have any health or medical condition that might hinder you from committing to work?",
      options: ["Yes", "No"],
    },
    {
      id: 14,
      text: "What is your expected salary?",
      options: [],
    },
    {
      id: 15,
      text: "How old are you?",
      options: [],
    },
  ],
};

export const faqList = [
  {
    question: "I cannot access the system URL. What should I do?",
    answers: [
      "Ensure you are connected to the internet.",
      "Verify the URL is correct.",
      "Clear your browser cache or try a different browser.",
      "Contact IT support if the issue persists.",
    ],
  },
  {
    question: "My login credentials are not working.",
    answers: [
      "Double-check your email and password.",
      "Make sure Caps Lock is off.",
      "If forgotten, click 'Forgot Password' to reset.",
    ],
  },
  {
    question: "I was logged out during the exam.",
    answers: [
      "Ensure you maintain a stable internet connection.",
      "Re-login and re-attempt the exam if possible.",
    ],
  },
  {
    question: "I cannot find the exam in my dashboard.",
    answers: [
      "Referesh the page.",
      "Agree the Data Privacy Notice if prompted.",
      "Contact the recruitment team if the issue persists.",
    ],
  },
  {
    question: "Exam page is loading or is stuck.",
    answers: [
      "Try refreshing the page.",
      "Ensure you have a stable internet connection.",
      "If the issue persists, try a different browser or device.",
    ],
  },
  {
    question: "I am unable to submit my answers.",
    answers: [
      "Ensure all required questions are answered.",
      "Check your internet connection.",
      "Try reloading the page or using a different browser.",
    ],
  },
  {
    question: "My exam audio is not playing.",
    answers: [
      "Some assessments are reviewed manually (e.g., ASMC, mock calls).",
      "Try using headphones.",
      "Reload the page or try a different browser.",
    ],
  },
  {
    question: "I submitted my answers, but I don’t see my score.",
    answers: [
      "Ensure your device audio is enabled.",
      "Check your dashboard later or wait for a result notification via email.",
      "If it’s been over 2-3 days, contact the recruitment team for updates.",
    ],
  },
  {
    question: "My dashboard says 'Pending' or 'Incomplete'. What should I do?",
    answers: [
      "This means you have not completed all required assessments.",
      "Check your dashboard for pending tasks and complete them.",
      "Check if you have remaining attempts for the exam and re-attempt.",
      "If you believe this is an error, contact the recruitment team.",
    ],
  },
  {
    question: "Can I retake a test if I fail or encounter an error?",
    answers: [
      "Yes, you can retake a test if you fail or encounter an error.",
      "If you have remaining attempts, you can re-attempt the exam.",
      "If you have exhausted your attempts, contact the recruitment team for further assistance.",
    ],
  },
  {
    question: "I passed the test. What’s next?",
    answers: [
      "Congratulations on passing the test!",
      "You will receive an email notification with further instructions.",
      "Please check your email regularly for updates.",
      "If you have any questions, feel free to reach out to the recruitment team.",
    ],
  },
  {
    question: "I have a question that is not listed here. Who can I contact?",
    answers: [
      "If you have any questions that are not listed in the FAQ, please reach out to the Recruitment Team.",
      "You can contact them via email at ",
    ],
  },
];

export const testResults = [
  {
    userId: 101,
    testId: 1,
    typeId: 1,
    sectionResults: [
      {
        sectionId: 1,
        sectionType: "Grammar & Sentence Construction",
        typeId: 1,
        score: 8,
        totalQuestions: 10,
        timeTakenMinutes: 7,
      },
      {
        sectionId: 2,
        sectionType: "Sentence Completion Test (SCT)",
        typeId: 1,
        score: 5,
        totalQuestions: 5,
        timeTakenMinutes: 6,
      },
      {
        sectionId: 3,
        sectionType: "Listening Comprehension",
        typeId: 1,
        score: 4,
        totalQuestions: 5,
        timeTakenMinutes: 8,
      },
      {
        sectionId: 4,
        sectionType: "Verbal Communication & Pronunciation",
        typeId: 2,
        score: 8,
        feedback: "Good response to customer queries.",
        timeTakenMinutes: 10,
      },
      {
        sectionId: 5,
        sectionType: "Typing Speed & Accuracy",
        typeId: 3,
        score: 95,
        metrics: {
          WPM: 50,
          Accuracy: "95%",
        },
        timeTakenMinutes: 60,
      },
      {
        sectionId: 6,
        sectionType: "Reading Comprehension",
        typeId: 1,
        score: 7,
        totalQuestions: 10,
        timeTakenMinutes: 8,
      },
      {
        sectionId: 7,
        sectionType: "Mock Call / Live Chat Simulation",
        typeId: 2,
        score: null,
        feedback: null,
        timeTakenMinutes: 10,
      },
      {
        sectionId: 8,
        sectionType: "Basic Computer Literacy ",
        typeId: 1,
        score: 5,
        totalQuestions: 5,
        timeTakenMinutes: 5,
      },
    ],
    totalScore: 141,
    status: "Passed",
  },
];

export const sampleText2 = `
Subject: Update on Your Delayed Shipment

We appreciate your patience and thank you for choosing Sixeleven.


Best regards,
John Doe
Sixeleven
Support Team
`;

export const sampleText = `Subject: Update on Your Delayed Shipment
Dear Alex Johnson,
Thank you for reaching out regarding your order. I sincerely apologize for the delay and understand how frustrating this must be.
Upon checking our system, I see that your order was delayed due to a temporary warehouse issue. However, I'm happy to inform you that your package has now been processed for shipment and is scheduled for delivery within the next 48 hours.
To ensure you stay updated, I have sent your tracking details to your registered email. You can also track your order directly using this link: https://tracking.example.com/12345.
As a token of our apology for the inconvenience, we would like to offer you a 10% discount on your next purchase. Please use the code SHIP10 at checkout.
If you need any further assistance, please don't hesitate to reply to this email or contact our support team at support@example.com.
We appreciate your patience and thank you for choosing Sixeleven.
Best regards,
John Doe
Sixeleven
Support Team
`;

export const dataSection = [
  {
    sections: [
      {
        id: 1,
        sectionType: "Grammar & Sentence Construction",
        durationMinutes: 8,
        type: "MCQ",
        instructions:
          "Choose the grammatically correct option in each multiple-choice question.",
        passage: null,
        questions: [
          {
            question: "The manager ___ the report before the deadline.",
            options: ["submits", "submitted", "submit"],
            answer: "submitted",
          },
          {
            question:
              "Neither of the customers ___ satisfied with the service.",
            options: ["were", "was", "are"],
            answer: "was",
          },
          {
            question:
              "If the internet connection drops, the agent ___ reset the router.",
            options: ["must", "should", "will"],
            answer: "must",
          },
          {
            question:
              "The employee was promoted ___ his excellent performance.",
            options: ["because", "due to", "despite"],
            answer: "due to",
          },
          {
            question: "Please let me know when the documents ___ ready.",
            options: ["is", "are", "were"],
            answer: "are",
          },
        ],
      },
      {
        id: 2,
        sectionType: "Sentence Completion Test (SCT)",
        type: "MCQ",
        durationMinutes: 8,
        weight: 0.05,
        instructions:
          "Complete the sentences in a meaningful way that reflects your thoughts or reasoning.",
        passage: null,

        questions: [
          {
            question:
              "After listening to the customer’s complaint, the agent ___.",
            options: [
              "ignored the complaint and moved on.",
              "apologized and put the customer on hold. ",
              "acknowledged the concern and assured the customer of a resolution.",
            ],
            answer: "ignored the complaint and moved on.",
          },
          {
            question: "If a customer is confused about a bill, I would ___.",
            options: [
              "tell them to read it again carefully.",
              "explain the charges but not offer further assistance.",
              "patiently break down the charges and answer their questions.",
            ],
            answer:
              "patiently break down the charges and answer their questions.",
          },
          {
            question:
              "When handling a call with a difficult customer, the best approach is to ___.",
            options: [
              "hang up if they are rude.",
              "listen but avoid getting involved.",
              "stay calm, listen actively, and offer solutions professionally.",
            ],
            answer:
              "stay calm, listen actively, and offer solutions professionally.",
          },
        ],
      },
      {
        id: 3,
        sectionType: "Listening Comprehension",
        type: "MCQ",
        durationMinutes: 8,
        instructions:
          "Listen to the audio clip and answer the questions based on what you hear.",
        passage: null,

        audioScript:
          "Customer: Hi, I received the wrong item in my order. Agent: I'm very sorry to hear that. Let me check your order and assist you right away.",
        questions: [
          {
            question: "What issue did the customer face?",
            options: [
              "Received a damaged item",
              "Item missing from order",
              "Received the wrong item",
              "Wants to cancel the order",
            ],
            answer: "Received the wrong item",
          },
          {
            question: "How did the agent respond?",
            options: [
              "Ignored the customer",
              "Apologized and offered help",
              "Transferred the call",
              "Said it was not their fault",
            ],
            answer: "Apologized and offered help",
          },
          {
            question: "What should the agent do next?",
            options: [
              "Check the order details",
              "Hang up the call",
              "Ask the customer to call back later",
              "Tell the customer to wait for a week",
            ],
            answer: "Check the order details",
          },
          {
            question: "What is the customer's tone in the conversation?",
            options: [
              "Angry and frustrated",
              "Calm and understanding",
              "Indifferent",
              "Excited",
            ],
            answer: "Angry and frustrated",
          },
          {
            question: "What is the main purpose of the agent's response?",
            options: [
              "To resolve the issue",
              "To end the call quickly",
              "To transfer the call to a manager",
              "To apologize without taking action",
            ],
            answer: "To resolve the issue",
          },
        ],
      },
      {
        id: 4,
        sectionType: "Verbal Communication & Pronunciation",
        type: "Recording",
        durationMinutes: 10,
        instructions:
          "Record yourself speaking clearly and fluently as you answer the prompt.",
        passage: null,

        prompt: [
          {
            subject: "Customer Support Message",
            msg: "Thank you for calling. I understand your concern, and I’ll do my best to resolve it. May I put you on hold for a moment while I check the details?",
          },
          {
            subject: "Information Disclosure",
            msg: "Your order is currently being processed, and we expect it to arrive within three days. If you have any concerns, we’re happy to assist you further.",
          },
          {
            subject: "Apology Statement",
            msg: "I sincerely apologize for the delay. We value your time and will do everything possible to resolve this quickly.",
          },
        ],
      },
      {
        id: 5,
        sectionType: "Typing Speed & Accuracy",
        type: "Typing",
        durationMinutes: 5,
        weight: 0.05,
        instructions:
          "Type the following sentence as quickly and accurately as you can.",
        prompt: [
          {
            subject: "Update on Your Delayed Shipment",
            msg: `Dear [Customer Name],
Thank you for reaching out regarding your order. I sincerely apologize for the delay and understand how frustrating this must be.
Upon checking our system, I see that your order was delayed due to a temporary warehouse issue. However, I’m happy to inform you that your package has now been processed for shipment and is scheduled for delivery within the next 48 hours.
To ensure you stay updated, I have sent your tracking details to your registered email. You can also track your order directly using this link: [Tracking Link].
As a token of our apology for the inconvenience, we would like to offer you a 10% discount on your next purchase. Please use the code SHIP10 at checkout.
If you need any further assistance, please don’t hesitate to reply to this email or contact our support team at [Customer Service Contact].
We appreciate your patience and thank you for choosing [Company Name].
Best regards,
[Your Name]
[Company Name]
[Customer Support Team]`,
          },
        ],
        evaluation: {
          type: "timed_response",
          metrics: ["WPM", "Accuracy"],
        },
      },
      {
        id: 6,
        sectionType: "Reading Comprehension",
        type: "MCQ",
        durationMinutes: 8,
        weight: 0.1,
        instructions:
          "Read the passage carefully and answer the questions that follow. ",
        passage:
          "A customer calls to report an issue with their internet connection. The agent follows a troubleshooting protocol, asking about the modem, cables, and recent updates. The customer confirms that all connections are properly set up, but the internet remains slow. The agent then checks for any service outages in the area and finds that there are no reported issues. After further investigation, the agent determines that the customer has exceeded their monthly data limit, which has triggered a speed reduction based on their subscription plan. The agent explains the situation and offers two options: (1) upgrade the plan to restore high-speed access immediately, or (2) wait until the next billing cycle when the speed will be reset. The customer decides to upgrade their plan, and the agent successfully processes the request. The customer confirms that their internet speed has improved and thanks the agent for their help.",
        questions: [
          {
            question: "What was the customer's initial complaint?",
            options: [
              "Their internet was not working at all.",
              "Their internet was slower than usual.",
              "Their modem was broken.",
            ],
            answer: "Their internet was slower than usual.",
          },
          {
            question:
              "What was the first step the agent took to troubleshoot the issue?",
            options: [
              " Advised the customer to restart their computer.",
              "Asked the customer about their modem and cable connections.",
              "Immediately offered an upgrade.",
            ],
            answer:
              "Asked the customer about their modem and cable connections.",
          },
          {
            question: "3.Why was the internet speed slow?",
            options: [
              "There was a service outage in the area. ",
              "The customer had exceeded their monthly data limit. ",
              "The customer was using an old modem.",
            ],
            answer: "The customer had exceeded their monthly data limit. ",
          },
          // Add 5 more questions
        ],
      },
      {
        id: 7,
        type: "Recording",
        sectionType: "Mock Call / Live Chat Simulation",
        durationMinutes: 10,

        instructions:
          "Participate in a simulated customer interaction. Respond as a customer service representative.",
        prompt: [
          {
            subject: "Refund Request Spiel (Frustrated Customer)",
            msg: null,
          },
        ],
      },

      {
        id: 8,
        sectionType: "Basic Computer Literacy ",
        type: "MCQ",
        durationMinutes: 8,
        instructions: "Choose the best answer for each question. ",
        passage: null,

        questions: [
          {
            question: "What is the keyboard shortcut for copying text?",
            options: ["Ctrl + X", "Ctrl + V", "Ctrl + C"],
            answer: "Ctrl + C",
          },
          {
            question: "What is the keyboard shortcut for pasting text?",
            options: ["Ctrl + P", "Ctrl + V", "Ctrl + Z"],
            answer: "Ctrl + V",
          },
          {
            question:
              "Which of the following is an example of an input device?",
            options: ["Monitor", "Keyboard", "Printer"],
            answer: "Keyboard",
          },
          {
            question: "What does 'HTTP' stand for?",
            options: [
              "HyperText Transfer Protocol",
              "High Transfer Text Protocol",
              "HyperText Transmission Process",
            ],
            answer: "HyperText Transfer Protocol",
          },
          {
            question: "What is the primary function of a firewall?",
            options: [
              "To store data",
              "To protect against unauthorized access",
              "To increase internet speed",
            ],
            answer: "To protect against unauthorized access",
          },
        ],
      },
    ],
  },
];
